/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_Invalid_TimesInputs */

const en_orders_logistics_invalid_times = /** @type {(inputs: Orders_Logistics_Invalid_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide valid check-in and checkout values.`)
};

const es_orders_logistics_invalid_times = /** @type {(inputs: Orders_Logistics_Invalid_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa valores validos para entrada y salida.`)
};

/**
* | output |
* | --- |
* | "Please provide valid check-in and checkout values." |
*
* @param {Orders_Logistics_Invalid_TimesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_invalid_times = /** @type {((inputs?: Orders_Logistics_Invalid_TimesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_Invalid_TimesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_invalid_times(inputs)
	return es_orders_logistics_invalid_times(inputs)
});